import React from 'react'
import RadioButton from '../../../../../../../../../components/Form/RadioButton'

import { AUTOMATIC, COST_CAP } from '../../../../../../../../../constants/campaigns'
import { BIDDING_TYPE } from '../../../../../../../CampaignForms/CampaignFacebookCreate/CampaignFacebookCreateForm/fields'

interface CostCapRadioButtonsProps {
  value: string
  setFieldValue: (field: string, value: any) => void
}

const CostCapRadioButtons: React.FC<CostCapRadioButtonsProps> = ({ value, setFieldValue }) => {
  return (
    <>
      <RadioButton
        id={AUTOMATIC}
        name={BIDDING_TYPE}
        value={AUTOMATIC}
        label="Lowest Cost"
        subText="Spend all my budget with the lowest possible cost per click (or landing page view)"
        selectedValue={value}
        setFieldValue={setFieldValue}
      />
      <RadioButton
        id={COST_CAP}
        name={BIDDING_TYPE}
        value={COST_CAP}
        label="Cost Limit"
        subText="Keep the average cost per click (or landing page view) below a limit"
        selectedValue={value}
        setFieldValue={setFieldValue}
      />
    </>
  )
}

export default CostCapRadioButtons
